<template>
    <div class="nav">
        <div class="nav_center">
            <div class="nav_logo">
                <div
                    style="width: auto;height: 100%;display: flex;flex-direction: row;align-items: center;justify-content: center;">
                    <img src="../assets/img/test.png" alt="" mode="hightFix" />
                    <span>科达智慧水务一体化平台</span>
                </div>
            </div>

            <div class="nav_nav">
                <div v-for="(item, index) in menuList" :key="index" class="titleTxt" :class="actIndex == index ? 'act' : ''"
                    @mouseenter="enter(index)" @mouseleave="leave()" @click="actIndexOne(index)">
                    <router-link :to="item.route">
                        {{ $t(item.title) }}
                    </router-link>
                    <div v-for="(ele, inde) in item.children" v-show="item.isHow" :key="inde" class="titleTxt_One"
                        @click="GetPutrouter(item, ele)">
                        <div class="livnk">
                            {{ ele.barseName }}
                        </div>
                        <router-link :to="item.route"> </router-link>
                    </div>
                </div>
            </div>

            <div class="language">
                <div class="languageAct" :class="[languageIndex == 1 ? 'languageAct' : 'language_act']"
                    @click="languageGetPut(1)">
                    中文&nbsp;
                </div>
                <div class="languageAct">
                    |
                </div>
                <div class="languageAct" :class="[languageIndex == 0 ? 'languageAct' : 'language_act']"
                    @click="languageGetPut(2)">
                    &nbsp;English
                </div>
            </div>
        </div>
        <!-- <div style="width: 100%;height: 0.5px;background-color: #e0e0e0;"></div> -->
    </div>
</template>
  
<script>
export default {
    name: 'NewHeader',
    data() {
        return {
            isHowIndex: 0,
            actIndex: localStorage.getItem('actindex'),
            title: '',
            menuList: [
                {
                    route: '/home',
                    title: 'menu.home',
                    isHow: false
                },
                {
                    route: '/product',
                    title: 'menu.product',
                    isHow: false,
                    titleOne: [
                        { barseName: 2, show: 0 },
                        { barseName: 2, show: 1 },
                        { barseName: 2, show: 2 },
                        { barseName: 2, show: 3 },
                        { barseName: 2, show: 4 }
                    ]
                },
                {
                    route: '/about',
                    title: 'menu.about',
                    isHow: false,
                    titleOne: [
                        // { barseName: this.$t('About.consulting'), show: 0 },
                        // { barseName: this.$t('About.memberCase'), show: 1 },
                        // { barseName: this.$t('About.alliance'), show: 2 }
                    ]
                },
            ],
            languageIndex: localStorage.getItem('englishFlag')
        }
    },
    watch: {},
    created() {

        if (!localStorage.getItem('actindex')) {
            this.actIndex = 0
            localStorage.setItem("actindex", 0);
        }

        if (!localStorage.getItem('englishFlag')) {
            this.languageIndex = 1
            localStorage.setItem("englishFlag", 1);
            this.$i18n.locale = 'zh'
        }
    },
    methods: {
        GetPutrouter() {

        },
        actIndexOne(v) {
            this.actIndex = v
            localStorage.setItem("actindex", v);
        },
        leave() {
            this.menuList[this.isHowIndex].isHow = false
        },
        enter(v) {
            this.isHowIndex = v
            this.menuList[v].isHow = true
        },
        // 搜索
        queryRet() {

            // console.log(this.inputName);
        },
        // 中英文切换
        languageGetPut(v) {
            if (v === 1) {
                this.languageIndex = 1
                localStorage.setItem('englishFlag', 1)
                this.$i18n.locale = 'zh'
                // this.reload()
            } else {
                this.languageIndex = 0
                localStorage.setItem('englishFlag', 0)
                this.$i18n.locale = 'en'
                // this.reload()
            }
        }
    }
}
</script>
  
<style type="text/less" scoped lang="less">
@import "../assets/css/header.less";
</style>
  